import FormikNumberInput from "../../../../formik-form-components/FormikNumberInput";
import React, { useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import useFetchAndTrace from "../../../../../utils/hooks/fetchWithTrace";
import settings from "../../../../../constants/settings";
import { PriceInfo } from "../../../../../reducers/models/parts";
import { ContainerDetailsFormValues } from "./constants";

export default function PriceField({
  partId,
  updatePrice,
}: {
  partId: string;
  updatePrice?: boolean;
}) {
  const { setFieldValue, values } =
    useFormikContext<ContainerDetailsFormValues>();
  const fetchAndTrace = useFetchAndTrace();

  const handleGetPrice = useCallback(
    async (response: Response) => {
      if (response.ok) {
        const price = (await response.json()) as PriceInfo | null;
        if (price !== null) {
          void setFieldValue("unitPrice", price.unit_price);
        }
      } else {
        throw Error("Failed to get part price");
      }
    },
    [setFieldValue],
  );

  useEffect(() => {
    if (values.lastCountedAmount && updatePrice) {
      void fetchAndTrace(
        `${settings.api_url}/parts/${partId}/price?quantity=${values.lastCountedAmount}`,
        handleGetPrice,
        null,
      );
    }
  }, [
    values.lastCountedAmount,
    fetchAndTrace,
    partId,
    handleGetPrice,
    updatePrice,
  ]);

  return <FormikNumberInput name={"unitPrice"} label={"Unit price"} min={0} />;
}
